const CLASSES = {
  INIT: 'btn-init'
}

const useCircleBtn = () => {
  const { INIT } = CLASSES

  const circleBtns = $('.circle-btn')

  circleBtns.each((i, el) => {
    const btn = $(el)
    if (btn.hasClass(INIT)) return;

    const spread = btn.find('.circle-btn_spread')
    const getSpreadPosition = e => {
      const { top: btnTop, left: btnLeft } = el.getBoundingClientRect()
      const { clientX, clientY } = e
      if (!btnTop || !btnLeft || !clientX || !clientY) return;

      const top = clientY - btnTop
      const left = clientX - btnLeft
      spread.css({ top: `${top}px`, left: `${left}px` })
    }

    btn.on('mouseenter', getSpreadPosition)
    btn.on('mouseleave', getSpreadPosition)

    btn.addClass(INIT)
  })
}

export {
  useCircleBtn
}